import { PATHS } from 'router/config';

/**
 * ТЗ 0084 — адреса карточек лида Kommo и кандидата дофинансирования, журнала
 * SMS по ним.
 *
 * Путь только из `PATHS`: путь, набранный шаблонной строкой, при
 * переименовании раздела даёт молчаливый 404, невидимый для tsc, сборки и
 * тестов (грабли `route-links-from-paths`). Параметры — через
 * `URLSearchParams`, а не склейкой.
 */
export interface IPageLocation {
  pathname: string;
  search: string;
}

const at = (pathname: string, params: Record<string, string>) => ({
  pathname,
  search: `?${new URLSearchParams(params).toString()}`,
});

/** Карточка лида (`/leads?lead=<id>`). */
export const leadLocation = (id: string): IPageLocation =>
  at(PATHS.leads, { lead: id });

/** ТЗ 0106: карточка лида сразу на вкладке «Путь». */
export const leadJourneyLocation = (id: string): IPageLocation =>
  at(PATHS.leads, { lead: id, tab: 'journey' });

/** Карточка кандидата дофинансирования (`/dofinansowanie?candidate=<id>`). */
export const fundingCandidateLocation = (id: string): IPageLocation =>
  at(PATHS.dofinansowanie, { candidate: id });

/**
 * Карточка оператора дофинансирования (`/dofinansowanie?operator=<id>`).
 *
 * Задачи #113/#114: оператор открывается из карточки кандидата, карточки
 * студента, связи задачи и календаря писем — поэтому построитель живёт здесь,
 * рядом с кандидатом, а не внутри раздела дофина. `?operator=` читает сама
 * страница (`Dofinansowanie.tsx`).
 */
export const dofinOperatorLocation = (id: string): IPageLocation =>
  at(PATHS.dofinansowanie, { operator: id });

/** Карточка окна набора (`/dofinansowanie?intake=<id>`). */
export const dofinIntakeLocation = (id: string): IPageLocation =>
  at(PATHS.dofinansowanie, { intake: id });

/** Адрес строкой — там, где нужен `href`, а не `to` роутера. */
export const locationHref = ({ pathname, search }: IPageLocation): string =>
  `${pathname}${search}`;

/** Журнал SMS, отфильтрованный на лида. */
export const leadSmsJournalLocation = (leadId: string): IPageLocation =>
  at(PATHS.sms, { lead: leadId });

/** Журнал SMS, отфильтрованный на кандидата дофинансирования. */
export const candidateSmsJournalLocation = (
  candidateId: string,
): IPageLocation => at(PATHS.sms, { candidate: candidateId });

/** ТЗ 0086: карточка студента (`/students/<id>/details`). */
export const studentCardLocation = (id: string): IPageLocation => ({
  pathname: PATHS.studentDetail.replace(':id', id),
  search: '',
});
